function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import ShadowBoxButton from './ShadowBoxButton';
import { hexToRgb } from '../../utils/color';
export var useStyles = makeStyles(function (theme) {
  var palette = theme.palette,
      transitions = theme.transitions;
  var rgb = hexToRgb(palette.grey[100]).join(',');
  var shadowDefault = "0 10px 20px -5px ".concat(palette.greyTransparent[10]);
  var shadowRaised = "0 10px 20px -5px rgba(".concat(rgb, ", 0.25)");
  return {
    root: function root(_ref) {
      var raised = _ref.raised;
      return {
        overflow: 'hidden',
        backgroundColor: palette.common.white,
        boxShadow: raised ? shadowRaised : shadowDefault,
        padding: 24,
        transition: transitions.create('box-shadow', {
          duration: transitions.duration.shortest
        })
      };
    },
    buttonStates: {
      '&:hover, &.Mui-focusVisible': {
        boxShadow: shadowRaised
      }
    }
  };
}, {
  classNamePrefix: 'ShadowBox'
});

var ShadowBox = function ShadowBox(props) {
  var component = props.component,
      className = props.className,
      raised = props.raised,
      other = _objectWithoutProperties(props, ["component", "className", "raised"]);

  var classes = useStyles({
    raised: raised
  });

  if (component === 'button') {
    return React.createElement(ShadowBoxButton, _extends({
      className: clsx(classes.root, classes.buttonStates, className)
    }, other));
  }

  return React.createElement(Box, _extends({
    className: clsx(classes.root, className)
  }, other));
};

ShadowBox.propTypes = {
  className: PropTypes.string,
  component: PropTypes.elementType,
  raised: PropTypes.bool
};
ShadowBox.defaultProps = {
  raised: false
};
export default ShadowBox;